export const errorMsg =
  "We can't sign into your account. Please try again later and contact us if the issue continues.";
